/* eslint-disable */
/* eslint-disable no-param-reassign */
import axios, { AxiosRequestConfig } from "axios";
import { msalInstance } from "msal";
import store from "./store/index";
import { triggerLogout } from "./store/slice/authSlice";


// --------------------------
// GLOBAL SAFE LOGOUT HANDLER
// --------------------------
let logoutInProgress = false;

const safeLogout = () => {
  if (logoutInProgress) {
    console.warn("Logout already in progress — ignoring duplicate call.");
    return;
  }

  logoutInProgress = true;

  console.warn("Triggering SAFE LOGOUT...");
  store.dispatch(triggerLogout());

  setTimeout(() => {
    logoutInProgress = false;
  }, 3000);
};


// --------------------------
// MSAL TOKEN HELPER
// --------------------------
const getAccessToken = async (): Promise<string | null> => {
  try {
    const account = msalInstance.getActiveAccount() ||
                    msalInstance.getAllAccounts()[0];
    console.log("GetAccessToken",account)
    if (!account) {
      console.warn("No account found. User must log in.");
      return null;
    }

    const silentRequest = {
      scopes: ["User.Read"],
      account
    };

    const response = await msalInstance.acquireTokenSilent(silentRequest);
    console.log("Response from silentToken",response)
    return response.accessToken;

  } catch (error: any) {
    console.warn("Silent token refresh failed:", error.errorCode);

    if (
      error.errorCode === "interaction_required" ||
      error.errorCode === "login_required" ||
      error.errorCode === "invalid_grant"
    ) {
      return null; // token expired → user must login manually
    }

    console.error("Unexpected token error:", error);
    return null;
  }
};


// --------------------------
// AXIOS CLIENT 1
// --------------------------
const client = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  responseType: "json",
});

client.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    config.headers = config.headers ?? {};

    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("No access token available — request may fail.");
    }

    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error)
);

client.interceptors.response.use(
  (response) => {
    return response; // normal 2xx responses
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 403 || status === 401) {
        console.warn("403/401 detected → SAFE LOGOUT");
        safeLogout();
      }
    }
    return Promise.reject(error);
  }
);


// --------------------------
// AXIOS CLIENT 2
// --------------------------
const clientInsightshub = axios.create({
  baseURL: `${process.env.REACT_APP_API_URL}`,
  responseType: "json",
});

clientInsightshub.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    config.headers = config.headers ?? {};

    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("No access token available — request may fail.");
    }

    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error)
);

clientInsightshub.interceptors.response.use(
  (response) => {
    return response; // normal 2xx responses
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 403 || status === 401) {
        console.warn("403/401 detected → SAFE LOGOUT");
        safeLogout();
      }
    }
    return Promise.reject(error);
  }
);


// --------------------------
// AXIOS CLIENT 3
// --------------------------
const clientPerformancePulse = axios.create({
  baseURL: process.env.REACT_APP_PP_API_URL || process.env.REACT_APP_API_URL,
  responseType: "json",
});

clientPerformancePulse.interceptors.request.use(
  async (config: AxiosRequestConfig) => {
    config.headers = config.headers ?? {};

    const token = await getAccessToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    } else {
      console.warn("No access token available — request may fail.");
    }

    config.headers["Content-Type"] = "application/json";
    return config;
  },
  (error) => Promise.reject(error)
);

clientPerformancePulse.interceptors.response.use(
  (response) => {
    return response; // normal 2xx responses
  },
  (error) => {
    if (error.response) {
      const status = error.response.status;
      if (status === 403 || status === 401) {
        console.warn("403/401 detected → SAFE LOGOUT");
        safeLogout();
      }
    }
    return Promise.reject(error);
  }
);


export default client;
export { clientInsightshub, clientPerformancePulse, getAccessToken };
